/**
 *@author: satyamurthy.a
 *@Description :
 **/
import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import { Input, Popconfirm, Tooltip, Button } from 'antd';
import { API_SERVICEREQ } from '../../../../../commons/api';
import translation from '../../../../../commons/translation';
import localStorage from '../../../../../utils/localStorage';

import { deleteById, getSRList } from '../../../Utils/FormCalls';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';

const SRList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  // const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  let config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['SRId'],
    firstTitle: 'SRId',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/SRDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    _getDataSource();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  const _getDataSource = async () => {
    const data = await getSRList('both');
    setDataSource(data);
  };

  // const _getUserList = async () => {
  //   const users = await getUsersList();
  //   setUserList(users);
  // };

  const edit = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const _deleteById = async (id) => {
    const siteId = localStorage.get('currentSite');
    const payload = {
      url: `${API_SERVICEREQ.DELETE}?Id=${id}&SiteId=${siteId}`,
      method: 'POST'
    };
    await deleteById(payload);
    _getDataSource();
  };

  const getColumnSearchProps = (dataIndex, columnName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${columnName}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}>
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button danger onClick={() => handleReset(clearFilters, confirm)} style={{ width: 90 }}>
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const { translationCache } = props;
  const columns = [
    {
      title: translation(props.translationCache, 'SR Id'),
      dataIndex: 'SRId',
      key: 'SRId',
      ...getColumnSearchProps('SRId', 'SR Id'),
      filter: true
    },
    {
      title: translation(props.translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description', 'Description')
    },
    {
      title: translation(props.translationCache, constant.site),
      dataIndex: 'SiteName',
      key: 'SiteName',
      filter: true
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            disabled={record.Status === 'Inactive'}
            style={{ marginRight: '5px' }}
            onClick={() => edit(record)}>
            <Tooltip title={translation(props.translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(
              props.translationCache,
              'Are you sure that you want to delete the ServiceRequest'
            )}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation(props.translationCache, constant.yes)}
            cancelText={translation(props.translationCache, constant.no)}>
            <Button>
              <Tooltip title={translation(props.translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];
  config = {
    title: translation(translationCache, 'Service Request'),

    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',

    filterType: 'ByAttributeValue',
    attributeList: ['SRId'],

    firstTitle: 'SRId',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',

    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/SRDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };
  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        // userList={userList}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(SRList);
